/**
 * Time and Interval Configuration
 *
 * This file contains all time-related constants including refresh intervals,
 * polling rates, and time duration calculations.
 * All values are in milliseconds unless otherwise noted.
 */

export const TIME_INTERVALS = {
  /**
   * Fear & Greed Index refresh interval
   * How often to fetch new market sentiment data
   */
  FEAR_GREED_REFRESH: 60 * 60 * 1000, // 60 minutes

  /**
   * Chat message polling interval
   * How often to check for new messages in active chats
   */
  CHAT_POLL: 2000, // 2 seconds

  /**
   * Video processing status check interval
   * How often to check if video processing is complete
   */
  VIDEO_STATUS_REFRESH: 5000, // 5 seconds
} as const;

export const TIME_DURATIONS = {
  /** One second in milliseconds */
  ONE_SECOND_MS: 1000,

  /** One minute in milliseconds */
  ONE_MINUTE_MS: 60 * 1000,

  /** One hour in milliseconds */
  ONE_HOUR_MS: 60 * 60 * 1000,

  /** One day in milliseconds */
  ONE_DAY_MS: 24 * 60 * 60 * 1000,

  /** One week in milliseconds */
  ONE_WEEK_MS: 7 * 24 * 60 * 60 * 1000,

  /** One month (30 days) in milliseconds */
  ONE_MONTH_MS: 30 * 24 * 60 * 60 * 1000,

  /** One year (365 days) in milliseconds */
  ONE_YEAR_MS: 365 * 24 * 60 * 60 * 1000,
} as const;

export const DEBOUNCE_DELAYS = {
  /** Video progress update debounce */
  VIDEO_PROGRESS: 500,

  /** Search input debounce */
  SEARCH_INPUT: 300,

  /** Form validation debounce */
  FORM_VALIDATION: 500,
} as const;
